import * as Yup from 'yup';

import { IUserListFilters } from '~/models/UserListFilters';

export const UserListFiltersSchema: Yup.SchemaOf<IUserListFilters> = Yup.object().shape(
  {
    start_register_at: Yup.string().test(
      'validar-data',
      'Data inserida é inválida',
      (value) => {
        if (value?.replaceAll('_', '').length === 10) {
          return true;
        }
        if (value?.replaceAll('_', '').length === 0) return true;
        return false;
      },
    ),
    register_status: Yup.string(),
    payment_status: Yup.string(),
    search: Yup.string(),
  },
);
